// Angular
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
// Global
import { Global } from '../../utils/global';
// Environment
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  private editProfileSource = new BehaviorSubject<any>({});
  editProfile = this.editProfileSource.asObservable();

  private headers = new HttpHeaders(
    {
      'user-banca-bt': environment.baseUser,
      'password-banca-bt': environment.basePassword,
    });

  constructor(
    private http: HttpClient
  ) { }

  getProfiles() {
    return new Promise<any>((resolve, reject) => {
      const httpOptions = {
        headers: this.headers,
      };
      this.http.get(`${Global.SECURITY_BASE_API_URL}api/SeguridadAcierto/Perfil/TodosLosUsuarios`, httpOptions).subscribe(
        result => {
          resolve(result);
        }, error => {
          reject(error);
        }
      );
    });
  }

  getUserProfile(data) {
    return new Promise<any>((resolve, reject) => {
      const httpOptions = {
        headers: this.headers,
        params: data,
      };
      this.http.get(`${Global.SECURITY_BASE_API_URL}api/SeguridadAcierto/Perfil/usuario`, httpOptions).subscribe(
        (result:any) => {
          if (result.codigo == 1) {
            resolve(result); 
          } else {
            reject();
          }
        }, error => {
          reject(error);
        }
      );
    });
  }

  createProfile(data: any) {
    return new Promise<any>((resolve, reject) => {
      const httpOptions = {
        headers: this.headers,
      };
      this.http.post(`${Global.SECURITY_BASE_API_URL}api/SeguridadAcierto/Perfil`, data, httpOptions).subscribe(
        result => {
          resolve(result);
        }, error => {
          reject(error);
        }
      );
    });
  }

  updateProfile(data: any) {
    return new Promise<any>((resolve, reject) => {
      const httpOptions = {
        headers: this.headers,
      };
      this.http.put(`${Global.SECURITY_BASE_API_URL}api/SeguridadAcierto/Perfil`, data, httpOptions).subscribe(
        result => {
          resolve(result);
        }, error => {
          reject(error);
        }
      );
    });
  }

  setProfile(data: any): void {
    this.editProfileSource.next(data);
  }
}
